import { useEffect } from 'react';
import { SelectedEquipmentInfo } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { useLoaderOverlay } from 'app/[lang]/[esite]/contexts/loader-overlay-context';
import useFilter from 'hooks/use-filter';
import { usePathMatch } from 'hooks/use-path-match';
import { CURRENT_PAGE } from 'app/[lang]/[esite]/(core)/_header/components/store/constants';
import { BlocksCheckboxChangeEvent } from '@blocks-web-components/events';

export const useToggleFilterByEquipment = (
  selectedEquipment: SelectedEquipmentInfo
) => {
  const { handleSortByEquipment } = useFilter();

  const isSearchPage = usePathMatch(CURRENT_PAGE[1].path);

  const {
    startTransition,
    setFilterByEquipment,
    filterByEquipment,
    setEquipment,
    equipment
  } = useLoaderOverlay();

  const handleCheckboxChange = (ev: BlocksCheckboxChangeEvent) => {
    setFilterByEquipment(ev.detail.checked);
    startTransition(() => {
      handleSortByEquipment(
        ev.detail.checked,
        selectedEquipment.model,
        selectedEquipment.serialNumber,
        isSearchPage
      );
    });
  };

  useEffect(() => {
    if (
      equipment.model !== selectedEquipment.model ||
      equipment.serialNumber !== selectedEquipment.serialNumber
    ) {
      setFilterByEquipment(true);
      setEquipment({
        model: selectedEquipment.model,
        serialNumber: selectedEquipment.serialNumber
      });
      startTransition(() => {
        handleSortByEquipment(
          true,
          selectedEquipment.model,
          selectedEquipment.serialNumber
        );
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    equipment.model,
    equipment.serialNumber,
    selectedEquipment.model,
    selectedEquipment.serialNumber
  ]);

  return {
    filterByEquipment,
    handleCheckboxChange
  };
};
